const AUTH_TOKEN = "authToken";
const USER = "user";
const Z_STACK_SPEED = "zStackSped";

function getToken() {
  const authToken = localStorage.getItem(AUTH_TOKEN);
  return authToken ?? null;
}

function setToken(authToken) {
  localStorage.setItem(AUTH_TOKEN, authToken);
}

function getUserInfo() {
  const userInfo = localStorage.getItem(USER);
  return userInfo ? JSON.parse(userInfo) : null;
}

function setUserInfo(user) {
  localStorage.setItem(USER, JSON.stringify(user));
}

function deleteUserInfo() {
  localStorage.removeItem(USER);
  localStorage.removeItem(AUTH_TOKEN);
}

function setZStackSpeed(speed) {
  localStorage.setItem(Z_STACK_SPEED, speed);
}

function getZStackSpeed() {
  return localStorage.getItem(Z_STACK_SPEED);
}

const localStorageService = {
  getToken,
  setToken,
  getUserInfo,
  setUserInfo,
  deleteUserInfo,
  getZStackSpeed,
  setZStackSpeed,
}

export default localStorageService;